module.exports = __webpack_public_path__ + "static/media/fee.ac005b3b.svg";